import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UnsavedChangesService {
  readonly hasUnsavedChanges = signal(false);

  constructor() {
    window.addEventListener('beforeunload', (event) => {
      if (this.hasUnsavedChanges()) {
        event.preventDefault();
        event.returnValue = '';
      }
    });
  }

  set(value: boolean): void {
    this.hasUnsavedChanges.set(value);
  }

  confirmDiscard(message = 'You have unsaved changes. Are you sure you want to leave?'): boolean {
    if (!this.hasUnsavedChanges()) return true;
    return window.confirm(message);
  }
}
